import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { MyDateTimePicker, SingleSelect } from "@westcut/lib-client-common";
import { useBlockCreateMutation } from "../../Generated/graphql";
import { useData } from "../../Provider/Data";

interface Props {
  onClose: () => void;
  onSuccess: () => void;
}

export const Custom: React.FC<Props> = ({ onClose, onSuccess }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { operator, operators } = useData();
  const [getOperatorId, setOperatorId] = React.useState<number>(operator.id);
  const [getFrom, setFrom] = React.useState<Date>(new Date());
  const [getTo, setTo] = React.useState<Date>(new Date());
  const [create, { loading }] = useBlockCreateMutation();
  const processCreate = () => {
    create({
      variables: {
        input: {
          operatorId: getOperatorId,
          from: getFrom,
          to: getTo,
        },
      },
      update: () => {
        onSuccess();
      },
    });
  };
  return (
    <Dialog fullScreen={fullScreen} open onClose={onClose} maxWidth="md">
      <DialogContent>
        <Typography color="textSecondary" variant="h4" gutterBottom>
          Poser une pause
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12}>
            <SingleSelect
              disableClearable
              currentValue={getOperatorId}
              label="Coiffeur"
              setNewValue={(value) => setOperatorId(value || operator.id)}
              options={operators.map(({ id, name }) => ({
                label: name,
                value: id,
              }))}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <MyDateTimePicker
              label="De"
              value={getFrom}
              onChange={(value) => setFrom(value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <MyDateTimePicker
              label="À"
              value={getTo}
              onChange={(value) => setTo(value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Button onClick={onClose} color="secondary" disabled={loading}>
          Annuler
        </Button>
        <Button onClick={processCreate} color="primary" disabled={loading}>
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  );
};
